import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { Spin } from 'antd';

import MainLayout from '../layout/MainLayout';
import AnalyticalIndicators from '../pages/AnalyticalIndicators';
import Indicators from '../pages/ArmList';
import CommodityExchange from '../pages/CommodityExchange';
import Ecology from '../pages/Ecology';
import Economic from '../pages/Economic';
import Education from '../pages/Education';
import PopulationForecast from '../pages/Forecast/Population';
import VRPForecast from '../pages/Forecast/VRP';
import ForgotPassword from '../pages/ForgotPassword';
import HealthCare from '../pages/HealthCare';
import Home from '../pages/Home';
import Login from '../pages/Login';
import NotFound from '../pages/NotFound';
import OperationalSummary from '../pages/OperationalSummary';
import Profile from '../pages/Profile';
import ResetPassword from '../pages/ResetPassword';
import RoadConstruct from '../pages/RoadConstruct';
import Safety from '../pages/Safety';
import Social from '../pages/Social';
import Transport from '../pages/Transport';
import VideoStream from '../pages/VideoStream';
const URL_COMPONENTS = {
  '/safety': Safety,
  '/ecology': Ecology,
  '/economic': Economic,
  '/transport': Transport,
  '/videostream': VideoStream,
  '/education': Education,
  '/analytical-indicators': AnalyticalIndicators,
  '/forecast/population': PopulationForecast,
  '/forecast/vrp': VRPForecast,
  '/social': Social,
  '/commodity-exchange': CommodityExchange,
  '/healthcare': HealthCare,
  '/operational-summary': OperationalSummary,
  '/road-construction': RoadConstruct,
};

class Router extends Component {
  currentUserPayload = null;

  constructor(props) {
    super(props);
    this.state = {
      navigation: [],
      authReady: false,
    };
  }

  async componentDidMount() {
    window.addEventListener('storage', this.handleStorageUpdate);

    const user = await this.waitForUser();

    if (user) {
      this.getNav(user);
    }

    this.setState({ authReady: true });

    // iframe observer (оставляем как есть)
    (function () {
      const isBad = (el) =>
        el &&
        el.tagName === 'IFRAME' &&
        /position\s*:\s*fixed/i.test(el.getAttribute('style') || '') &&
        /2147483647/.test(el.getAttribute('style') || '');

      const mo = new MutationObserver((muts) => {
        for (const m of muts) {
          for (const n of m.addedNodes) {
            if (n.nodeType === 1) {
              if (isBad(n)) {
                n.remove();
              }
              n.querySelectorAll?.('iframe').forEach((ifr) => {
                if (isBad(ifr)) {
                  ifr.remove();
                }
              });
            }
          }
        }
      });

      mo.observe(document.documentElement, { childList: true, subtree: true });
    })();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.syncNavigationFromStorage();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('storage', this.handleStorageUpdate);
  }

  waitForUser = () => {
    return new Promise((resolve) => {
      const start = Date.now();

      const interval = setInterval(() => {
        const data = localStorage.getItem('user_params');

        if (data) {
          clearInterval(interval);
          resolve(data);
        }

        // таймаут 3 секунды
        if (Date.now() - start > 3000) {
          clearInterval(interval);
          resolve(null);
        }
      }, 50);
    });
  };

  handleStorageUpdate = (event) => {
    if (event.key === 'user_params') {
      this.syncNavigationFromStorage();
    }
  };

  syncNavigationFromStorage = () => {
    const payload = localStorage.getItem('user_params');
    if (payload === this.currentUserPayload) return;

    if (!payload) {
      this.currentUserPayload = null;
      this.setState({ navigation: [] });
      return;
    }

    this.getNav(payload);
  };

  getNav = (payload) => {
    if (!payload) return;

    const userPayload = typeof payload === 'string' ? payload : JSON.stringify(payload);
    let user = null;

    try {
      user = typeof payload === 'string' ? JSON.parse(payload) : payload;
    } catch (e) {
      this.currentUserPayload = null;
      this.setState({ navigation: [] });
      return;
    }

    if (!user?.roles?.length) {
      this.currentUserPayload = userPayload;
      this.setState({ navigation: [] });
      return;
    }

    const { tabs, subtabs } = user.roles[0];

    const navigation = tabs
      .map((tab) => ({
        ...tab,
        children: subtabs.filter((subtab) => subtab.tabId === tab.id),
      }))
      .filter((e) => e.children.length);

    this.currentUserPayload = userPayload;
    this.setState({ navigation });
  };

  render() {
    const { navigation, authReady } = this.state;

    if (!authReady) {
      return (
        <div
          style={{
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: '#141414',
          }}
        >
          <Spin size="large" tip="Загрузка данных..." style={{ color: '#fff', fontSize: 18 }} />
        </div>
      );
    }
    // return (
    //   <Switch>
    //     <Route exact path="/signin" component={Login} />
    //     <Route path="/forgot-password" element={<ForgotPassword />} />
    //     <Route path="/reset-password" element={<ResetPassword />} />
    //     <Route exact path="/" render={(props) => <MainLayout {...props} component={Home} />} />
    //     {navigation.map((tab) => {
    //       const url = tab.url.split('cc.krgsc.kz')[1];
    //       return (
    //         <Route
    //           path={url}
    //           exact
    //           key={tab.id}
    //           render={(props) => (
    //             <MainLayout {...props} component={URL_COMPONENTS[url]} subtabs={tab.children} />
    //           )}
    //         />
    //       );
    //     })}{' '}
    //     <Route
    //       path="/profile"
    //       exact
    //       render={(props) => <MainLayout {...props} component={Profile} />}
    //     />
    //     <Route
    //       path="/indicators"
    //       exact
    //       render={(props) => <MainLayout {...props} component={Indicators} />}
    //     />
    //     <Route
    //       path="/road-construction"
    //       exact
    //       render={(props) => <MainLayout {...props} component={RoadConstruct} />}
    //     />
    //     <Route render={(props) => <MainLayout {...props} component={NotFound} />} />
    //   </Switch>
    // );
    return (
      <Switch>
        <Route exact path="/signin" component={Login} />
        <Route exact path="/" render={(props) => <MainLayout {...props} component={Home} />} />

        {navigation.map((tab) => {
          const url = tab.url.split('cc.krgsc.kz')[1];
          return (
            <Route
              path={url}
              exact
              key={tab.id}
              render={(props) => (
                <MainLayout {...props} component={URL_COMPONENTS[url]} subtabs={tab.children} />
              )}
            />
          );
        })}

        <Route
          path="/profile"
          exact
          render={(props) => <MainLayout {...props} component={Profile} />}
        />

        <Route
          path="/indicators"
          exact
          render={(props) => <MainLayout {...props} component={Indicators} />}
        />

        <Route
          path="/road-construction"
          exact
          render={(props) => <MainLayout {...props} component={RoadConstruct} />}
        />

        <Route render={(props) => <MainLayout {...props} component={NotFound} />} />
      </Switch>
    );
  }
}

export default withRouter(Router);
